export default "__VITE_ASSET__eXpn3Tj7__"